export default "__VITE_ASSET__D_$47oVM__"